export function shouldDeferCatalogLayout(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/archive" ||
    pathname.startsWith("/archive/") ||
    pathname === "/history" ||
    pathname.startsWith("/history/")
  );
}

export function shouldInitializeCatalogLayout(
  deferChildren: boolean,
  isLayoutInitialized: boolean,
): boolean {
  return deferChildren && !isLayoutInitialized;
}
